export class JobVoucherPrint {
    constructor(public JID?, public LID?, public Des?, public Amo?) { }
}